import React from "react";
import { Link } from "react-router-dom";

/**
 * Uygulama Footer'ı. Hem oturumlu ekranlarda (Layout altı) hem oturumsuz
 * sayfalarda (Login / Register) kullanılabilir. Mobilde sarılır, masaüstünde
 * iki bölmeli görünür.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/60 bg-background/70 backdrop-blur mt-8" data-testid="app-footer">
      <div className="max-w-6xl mx-auto px-4 py-5 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-muted-foreground">
        <div className="flex flex-col gap-0.5">
          <div className="font-display font-semibold text-foreground">Colossae Hotel · Personel Yönetim Sistemi</div>
          <div>© {year} — Tüm hakları saklıdır.</div>
        </div>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/privacy" className="hover:text-foreground underline decoration-dotted" data-testid="footer-privacy">
            Gizlilik Politikası
          </Link>
          <Link to="/terms" className="hover:text-foreground underline decoration-dotted" data-testid="footer-terms">
            Kullanım Şartları
          </Link>
          <Link to="/guide" className="hover:text-foreground underline decoration-dotted" data-testid="footer-guide">
            Kullanım Kılavuzu
          </Link>
        </nav>
      </div>
    </footer>
  );
}
